import React, { PureComponent } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlus,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'

import './AppBar.css'

library.add(
  faPlus,
  faTimes,
);

class AppBar extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showDescription: false,
    };
  }

  getIcon(name) {
    switch (name) {
      case 'portfolio-analysis':
        return 'Money.svg'
      case 'performance-at-a-glance':
        return 'Line-Chart.svg'
      default:
        return '';
    }
  }

  mouseOn() {
    this.setState({
      showDescription: true,
    });
  }

  mouseOff() {
    this.setState({
      showDescription: false,
    });
  }

  render() {
    const {
      title,
      description,
      name,
      divId,
      activeApp,
      selectCallback,
      isFP,
      isLoggedIn
    } = this.props;

    const titleLink = 'take a video tour';
    let appStyle = 'primaryBarStyle';
    let columnClass = 'col-md-4';
    let iconHolderStyle = 'iconHolderStyle';
    let titleStyle = 'titleStyle';
    let titleStyleVideo = 'titleStyleVideo';
    let aniStyle = 'aniStyle';
    let closeStyle = 'closeStyle';
    let iconStyle = 'iconStyle';

    if (activeApp === name) {
      appStyle = 'primaryBarStyleOn';
      columnClass = 'col-md-12';
      titleStyle = 'titleStyleOn';
      titleStyleVideo = 'titleStyleVideoOn';
      iconHolderStyle = 'iconHolderStyleOn';
      aniStyle = 'aniStyleOn';
      closeStyle = 'closeStyleOn';
      if (window.matchMedia('(max-device-width: 1023px)').matches) {
        titleStyle = 'titleStyleOnMobile';
      }
    } else if (activeApp !== '') {
      appStyle = 'primaryBarStyleOff';
      columnClass = 'col-md-4 col-sm-12';
    }

    return (
      <div className={columnClass + ' ' + aniStyle}>
        <div id={name + '-header'} className={appStyle} onMouseEnter={() => this.mouseOn()} onMouseLeave={() => this.mouseOff()} onClick={() => selectCallback(name)}>
          {activeApp === name &&
            <div className={closeStyle} ><FontAwesomeIcon size="lg" icon="times" /></div>
          }
          {activeApp === '' &&
            <div className={closeStyle}><FontAwesomeIcon size="lg" icon="plus" /></div>
          }
          <div className={iconHolderStyle}><img className={iconStyle} src={`${process.env.REACT_APP_BASE_URL}/icons/${this.getIcon(name)}`} /></div>

          {/* {(activeApp === 'fund-comparison' && !isLoggedIn && !isFP) &&
            <React.Fragment>
              <div id={name + '-link'} className={titleStyle} >{title} </div>
              <div id={name + '-video'} className={titleStyleVideo} > <a style={{ color: 'white', background: '#05A9B1' }}
                href='https://www.wisdomtree.com/-/media/us-media-files/multimedia/snapshots/wisdomtree-fund-comparison-tool.mp4' target='_new'>{titleLink}</a> </div>
            </React.Fragment>
          } */}
          {activeApp !== 'fund-comparison' &&
            <div className={titleStyle}>{title} </div>
          }
          {(activeApp !== name) &&
            <div className={'descriptionStyle'}>{description}</div>
          }
        </div>
        <div className={activeApp === name ? 'appOnStyle' : 'appOffStyle'} id={divId}></div>
      </div>
    );
  }
}

export default (AppBar);


// WEBPACK FOOTER //
// ./src/components/App/AppBar.js